import { simpleClient } from 'services/apiGatewayClient';
import { createService } from 'services/genericAPIGatewayService';
import { State } from 'store';
import { Group } from '../entities/group';
import { Service } from './services';

export const client = simpleClient<Group>();
const endpointCreator = () => '/groups';

export const { Actions, Selectors, Sagas } = createService<Group, Service.Groups>({
  service: Service.Groups,
  client,
  endpointCreator,
  stateConverter: (state: State) => state.clients.groups,
  sagas: ['GET', 'GET_COLLECTION', 'CREATE', 'UPDATE'],
  persistUpdates: true,
});
